<template>
  <ol class="process-steps">
    <li v-for="(step, i) in displaySteps" :key="i" class="process-card">
      <div class="process-num">{{ pad(i + 1) }}</div>
      <h3>{{ titleOf(step) }}</h3>
      <p>{{ bodyOf(step) }}</p>
    </li>
  </ol>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'process-steps',
  props: {
    steps: { type: Array, default: () => [] }
  },
  computed: {
    ...mapState(['locale']),
    displaySteps() {
      return (this.steps && this.steps.length) ? this.steps : []
    }
  },
  methods: {
    pad(n) {
      return n < 10 ? '0' + n : String(n)
    },
    titleOf(step) {
      if (this.locale === 'en') {
        return step.titleEn || step.titleZh || ''
      }
      return step.titleZh || step.titleEn || ''
    },
    bodyOf(step) {
      if (this.locale === 'en') {
        return step.bodyEn || step.bodyZh || ''
      }
      return step.bodyZh || step.bodyEn || ''
    }
  }
}
</script>
